<template>
  <div class="px-3 mb-1"
    :class="selected ? 'bg-purple-200 text-white rounded-lg' : 'hover:bg-purple-200 hover:rounded-lg hover:text-white'">
    <button v-if="isLogout" type="button" class="flex items-center justify-between py-4 w-full text-xs"
      @click.prevent="$emit('logout')">
      <div class="flex items-center">
        <font-awesome-icon :icon="icon" class="mr-3 w-4 h-4" />
        <span class="whitespace-nowrap overflow-hidden">{{ label }}</span>
      </div>
    </button>
    <button v-else-if="hasAction" type="button" class="flex items-center justify-between py-4 w-full text-xs"
      @click.prevent="$emit('invoke-action')">
      <div class="flex items-center">
        <font-awesome-icon :icon="icon" class="mr-3 w-4 h-4" />
        <span class="whitespace-nowrap overflow-hidden">{{ label }}</span>
      </div>
      <span v-if="badgeCount > 0"
        class="ml-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 min-w-[20px] text-center">
        {{ badgeCount > 99 ? '99+' : badgeCount }}
      </span>
    </button>
    <Link v-else class="flex items-center justify-between py-4 w-full text-xs" :href="link" :method="method" :as="as">
    <div class="flex items-center">
      <font-awesome-icon :icon="icon" class="mr-3 w-4 h-4" />
      <span class="whitespace-nowrap overflow-hidden">{{ label }}</span>
    </div>
    <span v-if="badgeCount > 0"
      class="ml-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 min-w-[20px] text-center">
      {{ badgeCount > 99 ? '99+' : badgeCount }}
    </span>
    </Link>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    icon: String,
    link: String,
    label: String,
    selected: Boolean,
    method: String,
    as: String,
    action: String,
    badge: Function,
  },
  emits: ['logout', 'invoke-action'],
  computed: {
    isLogout() {
      return this.link === '/logout'
    },
    hasAction() {
      return !!this.action
    },
    badgeCount() {
      if (typeof this.badge === 'function') {
        return this.badge()
      }
      return 0
    }
  }
}
</script>
